export enum DepositType {
    UNKNOWN = 0,
    NO_DEPOSIT = 1
}
